import React, { Ref } from "react";

import { StrainRelative } from "custom-types/StrainV2";

import StrainLineageLink from "./StrainLineageLink";

type Props = {
  parentRef: Ref<HTMLDivElement>;
  parent: StrainRelative;
};

const StrainLineageSingleParent = ({ parentRef, parent }: Props) => (
  <div className="lineage__center-parent" ref={parentRef}>
    <StrainLineageLink
      strain={parent}
      altText="Strain parent"
      parentOrChild="parent"
    />
    <style jsx>{`
      .lineage__center-parent {
        grid-column: 1 / 7;
        grid-row: 1 / 3;
      }
    `}</style>
  </div>
);

export default StrainLineageSingleParent;
